/**
 * Internal companies whose data is protected from impersonation access.
 * Changing this list requires a deployment — this is intentional.
 */
export const RESTRICTED_COMPANY_UIDS = new Set([
  'DdpkfaEVk8pBYzZjblwA', // cleverlohn GmbH (MD11)
  'ef56VOPYpMQG50OLDJ1u', // Integral Tax GmbH (MD733)
  'Ypopi95PgV4wIJu0DfVs', // Integral Services GmbH (MD910)
])
